import { render, staticRenderFns } from "./SearchArea.vue?vue&type=template&id=3a52c835&scoped=true&"
import script from "./SearchArea.vue?vue&type=script&lang=js&"
export * from "./SearchArea.vue?vue&type=script&lang=js&"
import style0 from "./SearchArea.vue?vue&type=style&index=0&id=3a52c835&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a52c835",
  null
  
)

export default component.exports